import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyShippingAddressReminderDialog = loadable(
  () => import(/* webpackChunkName: "shared/shipping-address-reminder-dialog" */ './ShippingAddress'),
  'ShippingAddressReminderDialog',
);
